import React, { useEffect, useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { gameStatusState } from '../../globalStates/general/gameStatus';
import { useRecoilState, useRecoilValue } from 'recoil';
import { thisGamePointState } from '../../globalStates/general/thisGameGetPoint';
import { donotHaveItemArr } from '../GameMain/Item/manageItemData';
import { saveGetItem } from '../../database/getItem';
import { useMedia } from 'use-media';


// 自分の持っているアイテムとすべてのアイテムを比べて持っていないアイテムをroadに表示させる。
// ゲットしたアイテムはデータベースのアイテムの配列に追加する
const ItemLoad = (props) => {
  const [contents, setContents] = useState("");
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const getPoint = useRecoilValue(thisGamePointState);
  const isPC = useMedia({ minWidth: '1000px' });

  const getItemIdThisGameArr = () => {
    let tmpArr = [];
    for (let i = 0; i < props.donotHaveItemArr.length; i++) {
      if (props.donotHaveItemArr[i][2][1] <= getPoint) {
        tmpArr[tmpArr.length] = (props.donotHaveItemArr[i][0]);
      }
    }
    return tmpArr;
  }

  const itemLoadStyle = css`
  opacity: 0;
  animation: fadeIn 1s ease-in forwards;
  animation-delay: 4s;
  position: absolute;

  right: ${isPC ? "25px" : "30px"};
  top: ${isPC ? "90px" : "0px"};
  width: 5vw;
  height: auto;
  padding: 50px;
  h4 {
    color: #555;
    padding: 0;
    white-space: nowrap;
  }


  .itemAreaWrap {
    position: relative;
    width: 5vw;
    height: auto;
  }
  .itemArea {
    margin-top: ${isPC ? "20px" : "0px"};
    width: 200px;
    height: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .getText {
    position: absolute;
    left: -50px;
    margin-top: 5px;
    padding-right: 15px;
    color: #1823f6;
    animation: moveLeft 2s ease-out infinite;
    animation-delay: 7s;
    @keyframes moveLeft {
      0% {
        transform: translateX(0px);
      }
      50% {
        transform: translateX(5px)
      }
      100% {
        transform: translateX(0px);
      }
    }
  }



  .circle {
      animation: backgroundCover 1s ease forwards;
      animation-delay: 5s;
      background-color: #555;
      @keyframes backgroundCover {
        0% {
          background-color: #555;
        }
        100% {
          background-color: #fff;
        }
      }
      transform: translateY(3px);
      width: 30px;
      height: 30px;
      border: 1px solid #918e8e;
      border-radius: 100%;
      position: relative;

      .itemPoint {
        opacity: 0;
        color: #555;
        animation: fadeIn 1s ease forwards;
        animation-delay: 5s;
        font-size: 12px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }

      @keyframes fadeIn {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

    }



    .itemName {
      background-color: #555;
      width: 100px;
      animation: fillBackground 1s ease-out forwards;
      animation-delay: 5s;
      margin-left: 10px;
      transform: translateY(3px);
      color: #555;
      white-space: nowrap;
      font-size: 0.8em;

      @keyframes fillBackground {
        0% {
          width: 100px;
          background-color: #555;
        }
        100% {
          width: 0px;
          background-color: #555;
        }
      }
    }

    .connectLine {
      position: absolute;
      top: 31px;
      transform: translateX(14px);
      left: 1px;
      width: 0.1px;
      background-color: #555;
      animation: extendTheLine 1s forwards;
      animation-delay: 6s;
      @keyframes extendTheLine {
        0% {
          height: 0px;
        }
        100% {
          height: 37px;
        }
      }
    }


  `;

  useEffect(() => {
    (async () => {
      const getItemIdArr = getItemIdThisGameArr();
      await saveGetItem(getItemIdArr);
      let tmpContents = [];
      for (let i = 0; i < props.donotHaveItemArr.length; i++) {
        if (getItemIdArr.includes(props.donotHaveItemArr[i][0])) { // 今回ゲットしたアイテム
          tmpContents.push(<div key={i} className='itemArea'><span className='getText'>get!</span><div className='circle'><span className='itemPoint'>{props.donotHaveItemArr[i][2][1]}</span><span className='connectLine'></span></div><div className='itemName'>{props.donotHaveItemArr[i][1]}</div></div>);
        } else { // その他
          tmpContents.push(<div key={i} className='itemArea'><div className='circle'><span className='itemPoint'>{props.donotHaveItemArr[i][2][1]}</span><span className='connectLine'></span></div><span className='itemName'>{props.donotHaveItemArr[i][1]}</span></div>);
        }
      }
      setContents(tmpContents);
    })()
  }, []);


  return (
    <>
      <div css={itemLoadStyle}>
        <h4>アイテム</h4>
        <div className='itemAreaWrap'>
          {contents}
        </div>
      </div>

    </>
  )
}

export default ItemLoad
